import { QueryCache, QueryClient } from '@tanstack/react-query'

import { recheckSessionOnUnauthorized, setCsrfHeader, setPosthogHeaders, shouldRetryQuery } from './auth'

/** Insure's one API cache: its pages and the shared shell's account menu read the same signed-in user. */
export const insureQueryClient: QueryClient = new QueryClient({
  queryCache: new QueryCache({ onError: (error) => recheckSessionOnUnauthorized(insureQueryClient, error) }),
  defaultOptions: {
    queries: { retry: shouldRetryQuery },
  },
})

declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__: import('@tanstack/query-core').QueryClient
  }
}
if (typeof window !== 'undefined') {
  window.__TANSTACK_QUERY_CLIENT__ = insureQueryClient
  setCsrfHeader()
  setPosthogHeaders()
}
